const NoImage = className => {
  return `<div class="no-image ${className}"><div class="no-image-inner"></div></div>`;
};

export default NoImage;
